import { DarkBlueCircle } from '../Ornaments/DarkBlueCircle';
import { LightPolygon } from '../Ornaments/LightPolygon';
import { SquashedCircle } from '../Ornaments/SquashedCircle';
import { Star } from '../Ornaments/Star';
import { WhiteBottomCircle } from '../Ornaments/WhiteBottomCircle';
import { Testimonial } from './Testimonial';

export const AVP = () => {
  return (
    <Testimonial
      company={
        <p className="text-[14px] font-medium leading-[150%] tracking-[2.8px] uppercase">
          Fortune 20 global retailer
        </p>
      }
      quote="Transcend's exceptional support and commitment to excellence have made them a trusted extension of our privacy, tech, and business teams. We moved from another provider to Transcend in order to support our C-suite digital governance initiatives, and from day one Transcend has provided seamless engagement and delivered robust implementation on user consent across our tech ecosystem."
      author={
        <>
          <span className="font-medium">Assistant Vice President, </span>
          eBusiness
        </>
      }
    >
      <SquashedCircle className="absolute ml:-top-65 -top-15 ml:right-50 right-20 ml:w-230 w-45" />
      <LightPolygon className="absolute ml:-top-80 ml:-left-200 ml:w-400 w-90 -left-40 top-20" />
      <WhiteBottomCircle className="absolute ml:-top-350 ml:right-[calc(50vw-350px)] ml:w-700 -top-80 left-90 ml:left-auto w-160" />
      <DarkBlueCircle className="absolute ml:-bottom-350 ml:-left-350 ml:w-800 w-150 -bottom-40 -left-70" />
      <Star className="absolute ml:bottom-150 bottom-30 ml:-right-200 -right-60 ml:w-400 w-135" />
    </Testimonial>
  );
};
